<template>

  <el-header class="my_header"
             style="height:52px;">
    <el-menu class="el-menu-demo"
             mode="horizontal"
             background-color="#1b88ee"
             @select="handleSelect"
             :default-active="isactive">
      <div class="logo">V货帮物流管理平台</div>
      <el-menu-item index="navSources"
                    v-bind:class="parentPath==='/manage'?'is-active':'a'">
        物流管理
      </el-menu-item>
      <el-menu-item v-if="$store.state.menuInfo.show"
                    index="navSys"
                    v-bind:class="parentPath==='/system'?'is-active':'a'">
        系统设置
      </el-menu-item>
      <el-col class="nav-userInfo">
        <span class="logout"
              @click="logoutHandle">退出</span>

        <el-dropdown trigger="click">
          <span class="el-dropdown-link username">
            你好，{{username}}！
            <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown"
                            class="userInfoList">
            <el-dropdown-item @click.native="handleShowinfoClick"> <span class="iconfont">&#xe615;</span> 个人信息</el-dropdown-item>
            <el-dropdown-item @click.native="handleShowPwdClick"> <span class="iconfont">&#xe600;</span> 修改密码</el-dropdown-item>
            <el-dropdown-item> <span class="iconfont">&#xe625;</span> 我的通知</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <span class="userImg">
          <img :src="imgUrl"
               alt="">
        </span>
      </el-col>
    </el-menu>
    <el-dialog title="修改密码"
               :visible.sync="showPwdDetails"
               class="pwdDetail"
               trigger="click"
               :before-close="handleClose">
      <div class="pwdItem">
        <label>原密码</label>
        <el-input type="password"
                  placeholder="请输入原密码"
                  v-model="originPwd"
                  maxlength='20'
                  minlength='6'></el-input>
      </div>
      <div class="pwdItem">
        <label>新密码</label>
        <el-input type="password"
                  v-model="newPwd"
                  placeholder="请输入6-20位数字、字母或字符"
                  maxlength='20'
                  minlength='6'></el-input>
      </div>
      <div class="pwdItem">
        <label>确认密码</label>
        <el-input v-model="newPwdAgain"
                  type="password"
                  placeholder="请再次输入"
                  maxlength='20'
                  minlength='6'></el-input>
      </div>
      <div class="pwdBtn">
        <div @click="handleCancelClick">取消</div>
        <div @click="handleConfirmClick">确认</div>
      </div>

    </el-dialog>
  </el-header>
</template>
<script>
// import { mapState } from 'vuex'
import { logout, changePassword } from 'apis/index'
export default {
  name: 'HomeHeader',
  props: ['isactive'],
  // computed: {
  //   ...mapState(['nav'])
  // },
  data () {
    return {
      username: '',
      imgUrl: 'http://img.zcool.cn/community/01528a58e4c8e6a801219c77b0154e.png@900w_1l_2o_100sh.jpg',
      showPwdDetails: false,
      originPwd: '',
      newPwd: '',
      newPwdAgain: '',
      parentPath: 'manage'
    }
  },
  methods: {
    // 判断header上物流管理和系统设置，点击以后内容切换到相应路径
    handleSelect (key, keyPath) {
      const path = keyPath[0]
      if (path === 'navSources') {
        this.parentPath = '/manage'
        this.$router.push('/manage')
      } else if (path === 'navSys') {
        this.parentPath = '/system'
        this.$router.push('/system')
      }
    },
    logoutHandle () {
      this.$confirm('确定退出登录吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        logout().then(res => {
          if (res.data.code === 200) {
            console.log(res)
            window.localStorage.removeItem('token')
            window.localStorage.removeItem('loginInfo')
            window.localStorage.removeItem('menulist')
            // this.$router.push('/login')
            this.$router.go(0)
          }
        })
      }).catch(() => {
      })
    },
    handleShowPwdClick () { // 打开显示修改密码框
      this.showPwdDetails = true
      // console.log('sss', this.showPwdDetails)
    },
    handleConfirmClick () { // 修改密码
      if (!this.originPwd | !this.newPwd | !this.newPwdAgain) {
        this.$message({
          showClose: true,
          message: '请填写密码',
          type: 'warning'
        })
      } else if (this.newPwd !== this.newPwdAgain) {
        this.$message({
          showClose: true,
          message: '新密码与确认密码不一致',
          type: 'warning'
        })
      } else if (this.newPwd.length < 6) {
        this.$message({
          showClose: true,
          message: '密码长度为6-20位数字、字母或字符',
          type: 'warning'
        })
      } else if (this.newPwd === this.originPwd) {
        this.$message({
          showClose: true,
          message: '新密码与原始密码相同',
          type: 'warning'
        })
      } else {
        // console.log('chushi', this.originPwd,
        //   'xin', this.newPwd,
        //   'xin2', this.newPwdAgain
        // )
        let newpassword = this.newPwd === this.newPwdAgain ? this.newPwd : ''
        changePassword({
          password: this.originPwd,
          newPassword: newpassword
        }).then(res => {
          // console.log(res)
          if (res.data.code === 201) {
            this.$message({
              showClose: true,
              message: '原始密码错误，请核对后重新输入',
              type: 'error'
            })
          }
          if (res.data.code === 200) {
            this.$message({
              showClose: true,
              message: '密码修改成功，请重新登录',
              type: 'success'
            })
            logout().then(res => {
              if (res.data.code === 200) {
                // window.localStorage.removeItem('token')
                // window.localStorage.removeItem('loginInfo')
                this.setCookie('', '', -1)
                this.$router.push('/login')
                // console.log('aaa')
              }
            })
          }
        })
      }
    },
    setCookie (loginname, loginPassword, exdays) {
      var exdate = new Date() // 获取时间
      exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdays) // 保存的天数
      // 字符串拼接cookie
      window.document.cookie = 'userName' + '=' + loginname + ';path=/;expires=' + exdate.toGMTString()
      window.document.cookie = 'userPwd' + '=' + loginPassword + ';path=/;expires=' + exdate.toGMTString()
    },
    handleCancelClick () { // 取消修改密码
      this.originPwd = ''
      this.newPwd = ''
      this.newPwdAgain = ''
      this.showPwdDetails = false
    },
    handleClose (done) {
      this.originPwd = ''
      this.newPwd = ''
      this.newPwdAgain = ''
      done()
    },
    handleShowinfoClick () { // 点击显示个人信息
      // this.$router.push({name: '/system/userinfo'})
      this.$router.push({ path: '/manage/userinfo', replace: true })
    }
  },
  mounted () {
    this.username = window.localStorage.getItem('username')
    this.parentPath = this.$route.matched[1].path
  }
}
</script>
<style lang="stylus">
@import '~styles/varibles.styl'
@import '~styles/mixins.styl'
.my_header
  line-height 52px
  padding 0
  font-family 'Microsoft YaHei', Arial
  background $bgColor
  .el-menu-demo
    height 52px
    line-height 52px
    .logo
      width 170px
      text-align center
      line-height 52px
      color #fff
      font-size 16px
      float left
      background $bgColor
  .el-menu--horizontal>.el-menu-item
    height 52px
    color #fff
    line-height 52px
    border-bottom none !important
    font-size 13px
  // .el-menu--horizontal>.el-menu-item.is-active
  // border-bottom none!important
  // color #fff
  // background rgba(255,255,255,0.18)!important
  .el-menu--horizontal>.el-menu-item.is-active
    border-bottom none !important
    color #fff
    background rgba(255, 255, 255, 0.18) !important
  .nav-userInfo
    float right
    width 330px
    font-size 13px
    height 52px
    outline none
    .logout
      margin-right 20px
      margin-left 10px
      cursor pointer
      color #fff
      font-size 13px
      float right
    .userImg
      width 28px
      height 28px
      float right
      border-radius 50%
      margin-right 10px
      overflow hidden
      margin-top 12px
      img
        width 100%
        vertical-align top
  .el-dropdown
    height 52px
    cursor pointer
    float right
    .username
      display inline-block
      color #fff
      font-size 13px
      min-width 140px
      ellipsis()
  .el-dropdown-menu
    top 40px !important
    padding 0
    .el-popper .popper__arrow, .el-popper .popper__arrow::after
      border-style none !important
  .el-dropdown-menu__item
    width 146px !important
    font-size 12px
  .pwdDetail
    font-size 12px
    .el-dialog
      width 444px
      height 268px
      border-radius 3px
      .el-dialog__header
        height 36px
        padding 0 20px 0
        border-bottom 1px solid #CFD5DC
        .el-dialog__title
          line-height 36px
          text-align center
          font-size 13px
          color #fff
          float left
          width 100%
          color #858C96
        .el-dialog__headerbtn
          top 12px
          right 12px
          .el-dialog__close
            color #858C96
            font-size 20px
      .el-dialog__body
        position relative
        height calc(100% - 52px)
        padding 0px
        padding-top 15px
        .pwdItem
          width 100%
          label
            width 115px
            text-align right
            display inline-block
            margin-right 10px
            font-size 12px
          .el-input
            width 220px
            height 32px
            .el-input__inner
              width 220px
              height 32px
          ::-webkit-input-placeholder /* WebKit browsers */
            font-size 12px !important
          :-moz-placeholder /* Mozilla Firefox 4 to 18 */
            font-size 12px !important
          ::-moz-placeholder /* Mozilla Firefox 19+ */
            font-size 12px !important
          :-ms-input-placeholder /* Internet Explorer 10+ */
            font-size 12px !important
        .pwdBtn
          width 100%
          height 34px
          background #f8f
          position absolute
          border-bottom-left-radius 3px
          border-bottom-right-radius 3px
          left 0
          bottom 0
          div
            width 50%
            height 34px
            float left
            text-align center
            cursor pointer
            line-height 34px
            &:nth-child(1)
              background #F7F9FB
              color #858C96
              border-bottom-left-radius 3px
            &:nth-child(2)
              background #1B88EE
              color #fff
              border-bottom-right-radius 3px
</style>
